import { module } from 'modujs';
import { html } from '../utils/environment'

export default class extends module {
    constructor(m) {
        super(m);
    }

    inview(e) {
        if(e.target != this.el) return

        html.classList.toggle('is-over-home-hero', e.way == 'enter')
    }

    destroy() {
        html.classList.remove('is-over-home-hero')
    }
}
